import { InjectionToken } from '@angular/core';
import { SublocationScope } from '../utils/sublocation-search.utils';

/**
 * WI 34968: the app-selected company and warehouse a free-text `typeahead-sublocation` loads
 * its list for. A lib cannot read an app's settings store, so the app provides a getter. It is
 * read once, when the control is created: a form left open while Settings changes keeps the
 * earlier warehouse, and its hint still names that warehouse. Optional: without it the control
 * lists nothing and its hint says no warehouse is selected.
 */
export const DYNAMIC_SUBLOCATION_SCOPE = new InjectionToken<
  () => SublocationScope | null
>('DYNAMIC_SUBLOCATION_SCOPE');
